<script type="text/javascript">
  export default {
  };
</script>

<template>
  <div class="leaderboards-info-loader">
    <div class="leaderboards-info-loader__text"></div>
    <div class="leaderboards-info-loader__position"></div>
  </div>
</template>

<style lang="scss">
  @import '~styles/settings';

  .leaderboards-info-loader {
    margin: 4px 0;
    padding: 12px 15px;
    background: $white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;

    &__text {
      height: 15px;
      opacity: 0.4;
      background-color: $blue2;
      width: 100px;
    }

    &__position {
      height: 15px;
      opacity: 0.4;
      background-color: $blue2;
      width: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content-loader/LeaderboardsInfoLoader.vue